import React__default from 'react';
import { P as PaginationDropdown } from './PaginationDropdown/PaginationDropdown-7WwxW7FS.js';
import { P as PaginationPageStatus } from './PaginationPageStatus/PaginationPageStatus-Djsre6ij.js';
import { P as PaginationFirstButton } from './PaginationButton/PaginationFirstButton-BcpzF0HV.js';
import { P as PaginationLastButton } from './PaginationButton/PaginationLastButton-Bgw4Ko0W.js';
import { P as PaginationNextButton } from './PaginationButton/PaginationNextButton-CoN9ZyO9.js';
import { P as PaginationPrevButton } from './PaginationButton/PaginationPrevButton-BPlq3iHL.js';
import { P as PaginationNavGroup } from './Pagination.styles-DKbw5qKK.js';
import { B as BasePagination } from './BasePagination-9q_1bNwe.js';

const renderDefaultPaginationDropdownLabel = pageSize => `${pageSize}`;
const Pagination = props => {
  const {
    id,
    currentPageLabel,
    firstPageLabel,
    lastPageLabel,
    nextPageLabel,
    prevPageLabel,
    pageSizes,
    currentPage,
    currentSize,
    totalPages,
    onSetPageSize,
    setCurrentPage,
    renderPaginationDropdownLabel = renderDefaultPaginationDropdownLabel,
    size = 'base',
    taktId,
    taktValue
  } = props;
  return /*#__PURE__*/React__default.createElement(BasePagination, {
    taktId: taktId,
    taktValue: taktValue,
    id: id
  }, /*#__PURE__*/React__default.createElement(PaginationDropdown, {
    id: `${id}-dropdown`,
    currentSize: currentSize,
    pageSizes: pageSizes,
    onSetPageSize: onSetPageSize,
    renderPaginationDropdownLabel: renderPaginationDropdownLabel,
    size: size
  }), /*#__PURE__*/React__default.createElement(PaginationPageStatus, {
    id: `${id}-page-status`,
    currentPageLabel: currentPageLabel,
    "aria-live": "polite",
    size: size
  }), /*#__PURE__*/React__default.createElement(PaginationNavGroup, {
    "aria-controls": `${id}-page-status`,
    "aria-labelledby": `${id}-page-status`
  }, /*#__PURE__*/React__default.createElement(PaginationFirstButton, {
    id: `${id}-first`,
    ariaLabel: firstPageLabel,
    onClick: () => setCurrentPage(0),
    disabled: currentPage === 0 || totalPages === 0,
    size: size,
    taktFallbackId: "first-button"
  }), /*#__PURE__*/React__default.createElement(PaginationPrevButton, {
    id: `${id}-prev`,
    ariaLabel: prevPageLabel,
    onClick: () => setCurrentPage(currentPage - 1),
    disabled: currentPage === 0 || totalPages === 0,
    size: size,
    taktFallbackId: "prev-button"
  }), /*#__PURE__*/React__default.createElement(PaginationNextButton, {
    id: `${id}-next`,
    ariaLabel: nextPageLabel,
    onClick: () => setCurrentPage(currentPage + 1),
    disabled: currentPage === totalPages - 1 || totalPages === 0,
    size: size,
    taktFallbackId: "next-button"
  }), /*#__PURE__*/React__default.createElement(PaginationLastButton, {
    id: `${id}-last`,
    ariaLabel: lastPageLabel,
    onClick: () => setCurrentPage(totalPages - 1),
    disabled: currentPage === totalPages - 1 || totalPages === 0,
    size: size,
    taktFallbackId: "last-button"
  })));
};

export { Pagination as P };
//# sourceMappingURL=Pagination-uW-pz5vE.js.map
